// @flow

import { type Merchant } from './types';

export function getLookAndFeel(merchant: Merchant): string {
  return merchant['look_and_feel'];
}
